export var defaultState = {
    isVisible: false,
    title: null,
    message: null,
    handleConfirm: null,
    confirmButtonIcon: 'remove',
    confirmButtonLabel: 'confirm.confirm',
    cancelButtonLabel: 'confirm.cancel',
};
